import { render, staticRenderFns } from "./MyBaby.vue?vue&type=template&id=164547b4&scoped=true"
import script from "./MyBaby.vue?vue&type=script&lang=js"
export * from "./MyBaby.vue?vue&type=script&lang=js"
import style0 from "./MyBaby.vue?vue&type=style&index=0&id=164547b4&prod&lang=scss&scoped=true"
import style1 from "./MyBaby.vue?vue&type=style&index=1&id=164547b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164547b4",
  null
  
)

export default component.exports